import React from "react";
import { ArrowRight, Calendar, Users } from "lucide-react";
import { Button } from "./ui/button";
import { trackCTAClick } from "../utils/analytics";

export const CTASection = ({ onApplyClick }) => {
  return (
    <section className="py-20 px-6 lg:px-8 bg-gradient-to-br from-purple-600 via-purple-700 to-indigo-700 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto text-center relative z-10">
        <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Ready to Start Your
          <span className="block mt-2">Acting Journey?</span>
        </h2>

        <p className="text-xl lg:text-2xl text-purple-100 mb-12 max-w-3xl mx-auto font-light">
          Join 3000+ actors who transformed their passion into a professional
          career with Barry John's legacy and guidance
        </p>

        {/* Urgency Indicators */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-12">
          <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">
            <Calendar className="w-6 h-6 text-white" />
            <div className="text-left">
              <div className="text-sm text-purple-200">Diploma Starts</div>
              <div className="font-bold text-white">Oct 19th, 2026</div>
            </div>
          </div>
          <div className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">
            <Users className="w-6 h-6 text-white" />
            <div className="text-left">
              <div className="text-sm text-purple-200">Weekend Starts</div>
              <div className="font-bold text-white">14th Nov, 2026</div>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <Button
          onClick={() => {
            trackCTAClick(
              "cta_section",
              "Apply Now - Secure Your Seat",
              "cta_section"
            );
            onApplyClick();
          }}
          size="lg"
          className="bg-white text-purple-700 hover:bg-gray-100 text-xl font-bold px-12 py-8 shadow-2xl hover:shadow-white/20 transition-all duration-300 hover:scale-105 group"
        >
          Apply Now - Secure Your Seat
          <ArrowRight className="ml-3 w-6 h-6 group-hover:translate-x-2 transition-transform" />
        </Button>

        <p className="mt-8 text-purple-200 text-sm">
          ⚡ Applications reviewed within 24 hours
        </p>
      </div>
    </section>
  );
};
